import apiClient from "./config";
import SUBSCRIPTION_PAYMENT_ENDPOINTS from "./endpoints/subscriptionPaymentEndpoint";

const subscriptionPaymentService = {
  subscriptionPayment: (data) => {
    return apiClient.post(
      SUBSCRIPTION_PAYMENT_ENDPOINTS.SUBSCRIPTION_PAYMENT,
      data
    );
  },
  subscriptionSuccess: (data) => {
    return apiClient.get(SUBSCRIPTION_PAYMENT_ENDPOINTS.SUBSCRIPTION_SUCCESS, {
      params: data,
    });
  },
  SubscriptionPreview: (data) => {
    return apiClient.post(SUBSCRIPTION_PAYMENT_ENDPOINTS.PREVIEW_SUBSCRIPTION, data);
  },
  getTransectionDetails: (data) => {
    return apiClient.get(SUBSCRIPTION_PAYMENT_ENDPOINTS.GET_PAYMENT_TRANSECTION, {
      params: data,
    });
  },
    cancelSubscription: (data) => {
    return apiClient.post(SUBSCRIPTION_PAYMENT_ENDPOINTS.CANCEL_SUBSCRIPTION, data);
  },
  dismissPlusMigration: () => {
    return apiClient.post(SUBSCRIPTION_PAYMENT_ENDPOINTS.DISMISS_PLUS_MIGRATION);
  },
  startTrial: (data = {}) => {
    return apiClient.post(SUBSCRIPTION_PAYMENT_ENDPOINTS.START_TRIAL, data);
  },
};

export default subscriptionPaymentService;
